import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact,} from '@fortawesome/free-brands-svg-icons';
import { faRobot, faShield} from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "JavaScript",
    "SQL",
    "Node.js",
    "Express.js",
    "MongoDB",
    "Mern",
    "Spring Boot",
    "Java",
    "Git"  
];

const labelsSecond = [
    "Kali Linux",
    "Metasploit",
    "Burp Suite",
    "Wireshark",
    "Nmap",
    "OSINT", 
];

const labelsThird = [
    "OpenAI",
    "GPT",
    "Hugging Face",
    "CloudVision",
    "Streamlit",
    "DeepSeek",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>FullStack Development</h3>
                    <p>
                    I build dynamic web applications using React and JavaScript, with a strong focus on clean UI and real-world functionality. While my main strength is frontend development, I'm actively expanding into backend technologies and cybersecurity to become a well-rounded full stack developer.
                    </p>
               <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                    
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faShield} size="3x"/>
                    <h3>Cibersecurity Enthusiast</h3>
                    <p>I have completed foundational courses in cybersecurity covering areas such as penetration testing, digital forensics, open-source intelligence (OSINT), vulnerability management, threat hunting, and network analysis. These studies provide me with the essential skills to identify, analyze, and respond to security threats effectively.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>

                    
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faRobot} size="3x"/>
                    <h3>AI Solutions</h3>
                    <p>I design and implement intelligent features in web applications by leveraging AI technologies such as natural language processing and image recognition. My projects often integrate APIs from leading AI platforms to enhance user experience, automate tasks, and provide insightful data analysis.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;